export default {
  pages: {
    key: "title",
    data: [
      // DASHBOARDS
      {title: "Dashboard",                  url: "/",                                  icon: "HomeIcon",            is_bookmarked: false},
      
    ]
  },
  files: {
    key:"file_name",
    data: [

    ]
  },
  contacts: {
    key:"name",
    data: [
    
    ]
  },
}
